import { EditableGridPage } from "@repo/ui";

import { useEnrollmentValidationErrorApi } from "../../api/eveAPI";
import { EVEProvider, useEVEContext, useRepContext } from "../../contexts/editableItemContext";
import { usePermissionsCheck } from "../../helpers/permissions";
import { useEntityId, useUpdateRoute } from "../../helpers/urlHooks";
import { EnrollmentValidationError } from "../../models";
import Editor from "./editor";
import Grid from "./grid";

function EnrollmentValidation() {
	return (
		<EVEProvider>
			<EnrollmentValidationsInternal />
		</EVEProvider>
	);
}

function EnrollmentValidationsInternal() {
	const { repId } = useRepContext();
	const { overwriteItem, pendingChanges } = useEVEContext();
	const { useEVEsQuery } = useEnrollmentValidationErrorApi();
	const eveQuery = useEVEsQuery(repId);
	const entityId = useEntityId();
	const updateRoute = useUpdateRoute();

	const { fullAPReadOnly } = usePermissionsCheck();

	const handleOpen = (item: EnrollmentValidationError) => {
		overwriteItem(item);
	};

	return (
		<EditableGridPage<EnrollmentValidationError>
			id="EnrollmnetValidationErrorContainer"
			items={eveQuery.data}
			keyProperty="id"
			Editor={Editor}
			Grid={Grid}
			openItem={handleOpen}
			pendingChanges={pendingChanges}
			itemsLoaded={eveQuery.loaded}
			entityId={entityId}
			updateRoute={updateRoute}
			fullReadOnly={fullAPReadOnly}
		/>
	);
}

export default EnrollmentValidation;
